<template>
    <div class="toolbar">
      <div class="filter-toggle">
        <button
          v-if="showFilterToggle"
          type="button"
          class="filter-toggle__button"
          @click="toggleFilters(); toggleSideBarFiltersDesktop()"
        >
          <span>{{ toggleButtonText }}</span>
          <div :class="{ 'rotate': toggleIcon }">
            <svg
                width="14"
                height="8"
                viewBox="0 0 14 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                role="img"
                aria-hidden="true"
            >
                <path
                d="M13 7L7 0.999999L1 7"
                stroke="#404040"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                ></path>
            </svg>
          </div>
        </button>
      </div>
      <div class="view">
        <span class="view__label">View as:</span>
        <div class="view__options">
          <button
            type="button"
            class="view__trigger view__trigger--mobile"
            data-column="1"
            @click="toggleColumnCount"
            :aria-label="getColumnLabel(1)"
          >
            <svg
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
              stroke="#404040"
              xmlns="http://www.w3.org/2000/svg"
              datagrid="data-column-1"
              role="img"
              :aria-label="getColumnLabel(1)"
            >
              <rect
                x="0.5"
                y="0.5"
                width="20"
                height="20"
                stroke="#404040"
              ></rect>
            </svg>
          </button>
          <button
            type="button"
            class="view__trigger view__trigger--mobile"
            data-column="2"
            @click="toggleColumnCount"
            :aria-label="getColumnLabel(2)"
          >
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              stroke="#404040"
              xmlns="http://www.w3.org/2000/svg"
              datagrid="data-column-2"
              role="img"
              :aria-label="getColumnLabel(2)"
            >
              <rect x="0.5" y="0.5" stroke="#404040" width="11" height="11"></rect>
              <rect x="0.5" y="13.5" stroke="#404040" width="11" height="11"></rect>
              <rect x="13.5" y="0.5" stroke="#404040" width="11" height="11"></rect>
              <rect x="13.5" y="13.5" stroke="#404040" width="11" height="11"></rect>
              <!-- <rect
                x="0.5"
                y="0.5"
                width="13"
                height="13"
                stroke="#404040"
              ></rect>
              <rect
                x="17.5"
                y="0.5"
                width="13"
                height="13"
                stroke="#404040"
              ></rect>
              <rect
                x="17.5"
                y="0.5"
                width="13"
                height="13"
                stroke="#404040"
              ></rect>
              <rect
                x="17.5"
                y="0.5"
                width="13"
                height="13"
                stroke="#404040"
              ></rect> -->
            </svg>
          </button>
          <button
            type="button"
            class="view__trigger view__trigger--desktop"
            data-column="2"
            @click="toggleColumnCount"
            :aria-label="getColumnLabel(2)"
          >
            <svg
              width="31"
              height="21"
              viewBox="0 0 31 21"
              fill="none"
              stroke="#404040"
              xmlns="http://www.w3.org/2000/svg"
              datagrid="data-column-2"
              role="img"
              :aria-label="getColumnLabel(2)"
            >
              <rect
                x="0.5"
                y="0.5"
                width="13"
                height="20"
                stroke="#404040"
              ></rect>
              <rect
                x="17.5"
                y="0.5"
                width="13"
                height="20"
                stroke="#404040"
              ></rect>
            </svg>
          </button>
          <button
            type="button"
            class="view__trigger view__trigger--desktop"
            data-column="4"
            @click="toggleColumnCount"
            :aria-label="getColumnLabel(4)"
          >
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 34 21"
              style="enable-background: new 0 0 34 21"
              xml:space="preserve"
              datagrid="data-column-4"
              class="active"
              role="img"
              :aria-label="getColumnLabel(4)"
            >
              <rect x="0.5" y="0.5" class="st0" width="6" height="8"></rect>
              <rect x="9.5" y="0.5" class="st0" width="6" height="8"></rect>
              <rect x="18.5" y="0.5" class="st0" width="6" height="8"></rect>
              <rect x="27.5" y="0.5" class="st0" width="6" height="8"></rect>
              <rect x="0.5" y="12.5" class="st0" width="6" height="8"></rect>
              <rect x="9.5" y="12.5" class="st0" width="6" height="8"></rect>
              <rect x="18.5" y="12.5" class="st0" width="6" height="8"></rect>
              <rect x="27.5" y="12.5" class="st0" width="6" height="8"></rect>
            </svg>
          </button>
        </div>
      </div>
    </div>
</template>
<script>
export default {
    name: "Toolbar",
    props: {
      showFilterToggle: {
        type: Boolean,
        default: true,
      },
    },
    data() {
        return {
            toggleIcon: false,
            toggleButtonText: "SHOW FILTERS",
            showFilters: false,
            showFilterPanel: false,
        }
    },
    mounted() {
        if (window.innerWidth <= 768) {
            this.toggleButtonText = "FILTER & SORT";
        } else {
            this.toggleButtonText = this.toggleButtonText === "HIDE FILTERS" ? "SHOW FILTERS" : "HIDE FILTERS";
        }
    },
    methods: {

        /**
         * Generate a label for column view buttons and icons, depending on the
         * number of columns.
         * @param {Number} count
         */
        getColumnLabel(count = 1) {
          return mint.Strings(
            'collections.view.columns',
            { replace: { count } }
          )
        },

        toggleColumnCount(e) {
            const columnView = e.target.closest('.view__trigger').getAttribute('data-column');
            this.$emit("columnCount", columnView);
        },
        toggleFilters() {
            this.showFilters = !this.showFilters;
            this.$emit("toggleFilters", this.showFilters);
        },
        toggleSideBarFiltersDesktop() {
            this.showFilterPanel = !this.showFilterPanel;
            this.toggleIcon = !this.toggleIcon;
            if (window.innerWidth <= 768) {
                this.toggleButtonText = "FILTER & SORT";
            } else {
                this.toggleButtonText = this.toggleButtonText === "HIDE FILTERS" ? "SHOW FILTERS" : "HIDE FILTERS";
            }
            this.$emit("toggleSideBarFiltersDesktop", this.showFilterPanel);
         },
    }
};
</script>
